//https://getbootstrap.com/docs/5.0/components/

//export { default as Alert } from 'bootstrap/js/src/alert';
//export { default as Button } from 'bootstrap/js/src/button';
//export { default as Carousel } from 'bootstrap/js/src/carousel';
//export { default as Popover } from 'bootstrap/js/src/popover';
//export { default as ScrollSpy } from 'bootstrap/js/src/scrollspy';
//export { default as Tab } from 'bootstrap/js/src/tab';
//export { default as Tooltip } from 'bootstrap/js/src/tooltip';
//export { default as Dropdown } from 'bootstrap/js/src/dropdown';
//export { default as Modal } from 'bootstrap/js/src/modal';
//export { default as Offcanvas } from 'bootstrap/js/src/offcanvas';
export { default as Collapse } from 'bootstrap/js/src/collapse';

document.addEventListener('DOMContentLoaded', function () {

    // loop through all .rca-carousel and setup main and thumbs with sync
    document.querySelectorAll('.rca-carousel').forEach(function (carousel) {
        let main = new Splide(carousel.querySelector('.rca-carousel__main'), {
            type: 'fade',
            fixedWidth: '100%',
            pagination: false
        });

        let thumbnails = new Splide(carousel.querySelector('.rca-carousel__thumbs'), {
            fixedHeight: 56,
            gap: 18,
            rewind: false,
            pagination: false,
            isNavigation: true,
            arrows: false,
            autoWidth: true,
            breakpoints: {
                600: {
                    fixedWidth: 60,
                    fixedHeight: 44,
                },
            },
        });

        main.sync(thumbnails);
        main.mount();
        thumbnails.mount();
    });

    // Initialize Parvus only when .lighbox exists
    if (document.querySelector('.lightbox')) {
        new Parvus({
            gallerySelector: '.rca-lighbox-gallery',
        });
    }

    const sortEl = document.querySelector('.rca-sort')
    if (sortEl) {
        var mixerConfig = {
            animation: {
                enable: false
            },
            selectors: {
                target: '.rca-grid__item'
            }
        }

        // Lets see if pagination is rendering, we gonna implement it only then
        const paginationEl = sortEl.querySelector('.rca-sort__pagination');
        if (paginationEl) {
            mixerConfig.pagination = {
                limit: paginationEl.getAttribute('data-limit')
            };
        }

        let mixer = mixitup(sortEl, mixerConfig);

        // Ranom order on load
        mixer.sort('random');

        if (paginationEl) {
            // Go to clicked page on pagination button click
            sortEl.querySelectorAll('.rca-sort__pagination-page').forEach(function (button) {
                button.addEventListener('click', function () {
                    //get page from aria-posinset attribute of parent
                    let page = this.parentElement.getAttribute('aria-posinset');
                    mixer.paginate(page).then(function (state) { setPaginationAria(); });
                });
            });
            // Go to prev page on prev button click
            sortEl.querySelector('.rca-sort__pagination-prev').addEventListener('click', function () {
                mixer.prevPage().then(function (state) { setPaginationAria(); });
            });
            // Go to next page on next button click
            sortEl.querySelector('.rca-sort__pagination-next').addEventListener('click', function () {
                mixer.nextPage().then(function (state) { setPaginationAria(); });
            });

            // Focus on first item of the list
            sortEl.querySelector('.rca-sort__go-first').addEventListener('click', function () {
                let state = mixer.getState();
                if (state.show.length > 0) {
                    state.show[0].querySelector('a').focus();
                }
            });

            // Function that sets correct aria attributes for current pagination page
            function setPaginationAria() {
                // Get all pagination buttons
                let paginationButtons = sortEl.querySelectorAll('.rca-sort__pagination-page');
                // Get current page
                let currentPage = mixer.getState().activePagination.page;

                // Loop through all pagination buttons
                paginationButtons.forEach(function (button) {
                    let checkedPage = button.parentElement.getAttribute('aria-posinset');
                    // If button is current page, set aria-current to page
                    if (checkedPage == currentPage) {
                        button.setAttribute('aria-current', 'true');
                        button.setAttribute('disabled', true);
                    } else {
                        button.removeAttribute('aria-current');
                        button.removeAttribute('disabled');
                    }

                    // handle disabling and enabling of prev/next buttons
                    if (currentPage == 1) {
                        sortEl.querySelector('.rca-sort__pagination-prev').setAttribute('disabled', true);
                    } else {
                        sortEl.querySelector('.rca-sort__pagination-prev').removeAttribute('disabled');
                    }

                    if (currentPage == mixer.getState().totalPages) {
                        sortEl.querySelector('.rca-sort__pagination-next').setAttribute('disabled', true);
                    } else {
                        sortEl.querySelector('.rca-sort__pagination-next').removeAttribute('disabled');
                    }

                    // change text of .rca-buttons__sr-page so it holds current page number
                    sortEl.querySelector('.rca-buttons__sr-page').innerHTML = currentPage;
                });
            }
        }
    }
});